import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import MysteryRevealCard from 'Components/Order/KeyReveals/MysteryRevealCard';

import 'Components/Order/KeyReveals/BonusDrop/BonusDropReveal.scss';

function BonusDropReveal({
  item,
  viewKeys,
  testReveal,
  testGame,
}) {
  const [showButton, setShowButton] = useState(false);
  const [showCard, setShowCard] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowButton(true);
    }, 7000);

    setTimeout(() => {
      setShowCard(true);
    }, 6600);
  }, [setShowButton]);

  return (
    <>
      <div className="BonusDropReveal">
        <video
          autoPlay
          muted
          playsInline
          className="hero-background hero-video"
        >
          <source src="https://cdn.fanatical.com/production/assets/mystery/bonus-drop/2025/bonus-drop-video.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="BonusDropReveal__content">
        <div className={classNames('BonusDropReveal__content__card', { 'BonusDropReveal__content__card--show': showCard })}>
          <MysteryRevealCard
            soundOn={false}
            game={testReveal ? testGame : item}
          />
        </div>

        {!testReveal &&
          <button
            className={classNames('MysteryReveal__revealButton MysteryReveal__revealButton--bonusdrop', { 'MysteryReveal__revealButton--hidden': !showButton })}
            onClick={() => { viewKeys(); }}
          >
            <FormattedMessage id="bonus-drop-reveal.button.view-key" defaultMessage="View your key" />
          </button>
        }
      </div>

      {showButton &&
        <div className="BonusDropReveal__fadeBackground" />
      }
    </>
  );
}

BonusDropReveal.propTypes = {
  item: PropTypes.shape({}),
  testGame: PropTypes.shape({}),
  viewKeys: PropTypes.func,
  testReveal: PropTypes.bool,
};

BonusDropReveal.defaultProps = {
  item: {},
  testGame: {},
  viewKeys: () => {},
  testReveal: false,
};

export default BonusDropReveal;
